














import InputField from "./InputField";
const Cleave = require("vue-cleave-component");

export default {
    name: "NumeralInput",
    components: { InputField, Cleave },
    props: {
        label: String,
        value: Number,
        unit: String,
        allowNegative: Boolean,
    },
    data() {
        return {
            editString: "",
            options: {
                numeral: true,
                numeralThousandsGroupStyle: "none",
                numeralPositiveOnly: this.allowNegative ? false : true,
            },
        };
    },
    created() {
        this.editString = this.value;
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.editString = this.value;
            },
        },
        editString: function () {
            this.$emit("input", parseFloat(this.editString));
        },
    },
};
